import { Button, Form, message, Modal, Table } from 'antd'
import React, { Fragment, useEffect, useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useReactToPrint } from 'react-to-print'
import API from '../../api'
import { hasPermission } from '../../api/user'
import OrderInfo from './orderInfo'
import styles from './order.module.scss'
import { IntTextFormatter } from '../helper/Integer/IntegerFormatter'
import moment from 'moment'

const { confirm } = Modal

const TableContent = ({ children }) => {
  return <div style={{ fontSize: "10px" }}>{children}</div>
}

export default function OrderEditPostmanPopup(props) {
  const order = props.order
  const onClose = props.onClose
  const [form] = Form.useForm()
  const [bonusForm] = Form.useForm()
  const language = useIntl()
  const componentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  useEffect(() => {
    if (props.order) {
      if (props.order.agent) {
        form.setFieldsValue({ agent_id: props.order.agent._id })
      }
      bonusForm.setFieldsValue({
        bonus: props.order.bonus ? props.order.bonus : 0,
      })
    }
  }, [props.order])

  const archiveOrder = async () => {
    confirm({
      title: language.formatMessage({ id: 'archive_question' }),
      onOk: async () => {
        try {
          await API.delete(`order/${order._id}`)
          onClose(true)
        } catch (err) {
          message.error(language.formatMessage({ id: 'order_archive_error' }))
        }
      },
    })
  }

  function showArchiveButton() {
    return (
      (order.status === 'PENDING' || order.status === 'PICKED') &&
      hasPermission('admin_archive_pending_progress_order')
    )
  }

  return (
    <Fragment>
      <OrderInfo {...props} />
      {showArchiveButton() && (
        <Button
          style={{ marginTop: 10, marginRight: 10 }}
          onClick={() => {
            archiveOrder()
          }}
          type="danger"
        >
          <FormattedMessage id="archive" />
        </Button>
      )}
      <Button
        style={{ marginTop: 10 }}
        onClick={() => {
          handlePrint()
        }}
        type="primary"
      >
        <FormattedMessage id="print" />
      </Button>
      <div className={styles.orderInfoContainer} ref={componentRef}>
        <div className={styles.headerContainer}>
          <div>
            {order.manager && (
              <div class={styles.print_normal_text}>
                <FormattedMessage id="manager" />: {order.manager.fullname}
              </div>
            )}
          </div>
          <div class={styles.print_normal_text}>
            <FormattedMessage id="status" />:
            {order.status === 'FINISHED' &&
              order.order_type &&
              order.order_type === 'RETURN'
              ? 'RETURN'
              : order.status}
          </div>
        </div>
        <div className={`${styles.clientInfoContainer}, ${styles.print_normal_text}`}>
          {order.client && (
            <div>
              <div>
                <FormattedMessage id="client" />: {order.client.fullname}
              </div>
            </div>
          )}
          {order.client && order.client.location.phone_number && (
            <div>
              <FormattedMessage id="phone_number" />:{' '}
              {order.client.location.phone_number}
            </div>
          )}
        </div>
        {order.comment && (
          <div className={`${styles.clientInfoContainer}, ${styles.print_normal_text}`}>
            <div>
              <FormattedMessage id="comment" />: {order.comment}
            </div>
          </div>
        )}
        <Table
          showSorterTooltip={false}
          bordered={true}
          size={'small'}
          className={'tableClass'}
          columns={[
            {
              title: <TableContent>{language.formatMessage({ id: 'product' })}</TableContent>,
              dataIndex: 'product',
              render: (product, record) =>
                <TableContent>{product ? product.description : record.description}</TableContent>,
            },
            {
              title: <TableContent content={language.formatMessage({ id: 'product_count' })} />,
              dataIndex: 'product_count',
              width: 100,
              render: (count) => <TableContent><IntTextFormatter number={count} /></TableContent>,
            },
            {
              title: <TableContent>{language.formatMessage({ id: 'product_price' })}</TableContent>,
              dataIndex: 'product_price',
              width: 120,
              render: (totalPrice, record) => (
                <TableContent><IntTextFormatter
                  number={record.product_price}
                  currencyText="֏"
                /></TableContent>
              ),
            },
            {
              title: <TableContent>{language.formatMessage({ id: 'total_price' })}</TableContent>,
              dataIndex: 'detail_price',
              width: 150,
              render: (totalPrice, record) => (
                <TableContent><IntTextFormatter
                  number={record.product_count * record.product_price}
                  currencyText="֏"
                /></TableContent>
              ),
            },
          ]}
          dataSource={order.order_details}
          pagination={false}
        />
        <div className={styles.footerContainer}>
          <div>
            <div class={styles.print_normal_text}>
              <FormattedMessage id="order_date" />:{' '}
              {moment(order.ordered_date).format('DD/MM/YYYY HH:mm:ss')}
            </div>
            {order.finished_date && (
              <div class={styles.print_normal_text}>
                <FormattedMessage id="finish_date" />:{' '}
                {moment(order.finished_date).format('DD/MM/YYYY HH:mm:ss')}
              </div>
            )}
            {order.client && order.client.balance && order.client.balance.total < 0 && (
              <div style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '10px' }}>
                <FormattedMessage id="debt" />: {Math.abs(order.client.balance.total)} {order.client.balance.currency_text || order.client.balance.currency}
              </div>
            )}
          </div>
          <div>
            <div class={styles.print_normal_text}>
              <FormattedMessage id="paid_amount" />:{' '}
              <IntTextFormatter number={order.payed_amount} currencyText="֏" />
            </div>
            <div class={styles.print_normal_text}>
              <FormattedMessage id="total_price" />:{' '}
              <IntTextFormatter number={order.total_price} currencyText="֏" />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
